import React from 'react'

const footer = () => {
  return (
    <section id='footer'>
  
       
  

  <div className="container.footer__container">
        <div className="footer_frontend">
          <h6>Portfolio created using React.js</h6>
          <h5>pratikshasanam@gmail.com</h5>
          
      </div>
      </div>
  
      </section>
  )
}

export default footer



